import { render, staticRenderFns } from "./AsideLeft.vue?vue&type=template&id=6522de5a&scoped=true"
import script from "./AsideLeft.vue?vue&type=script&lang=js"
export * from "./AsideLeft.vue?vue&type=script&lang=js"
import style0 from "./AsideLeft.vue?vue&type=style&index=0&id=6522de5a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6522de5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6522de5a')) {
      api.createRecord('6522de5a', component.options)
    } else {
      api.reload('6522de5a', component.options)
    }
    module.hot.accept("./AsideLeft.vue?vue&type=template&id=6522de5a&scoped=true", function () {
      api.rerender('6522de5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/businessHome/components/ClientUserWrap/AsideLeft.vue"
export default component.exports